import classNames from 'classnames/bind';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ROUTE_MAP } from '../../../services/route/route-names';
import { transitionToNextRoute } from '../../../services/route/route-navigation';
import Overlay from '../../shared/_deprecated/components/Overlay/Overlay';
import styles from './AppControls.scss';

const cx = classNames.bind(styles);

const ConnectedOverlay = ({
  showingOverlay,
  allowOverlayOnClick,
  overlayZindex,
}) =>
  showingOverlay && (
    <Overlay
      className={cx('app-controls__overlay')}
      isShowing={showingOverlay}
      zIndex={overlayZindex}
      onClick={
        allowOverlayOnClick ? () => transitionToNextRoute(ROUTE_MAP) : undefined
      }
    />
  );

ConnectedOverlay.propTypes = {
  showingOverlay: PropTypes.bool.isRequired,
  allowOverlayOnClick: PropTypes.bool.isRequired,
  overlayZindex: PropTypes.number.isRequired,
};

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (_dispatch) => ({});

const mapStateToProps = (state) => ({
  showingOverlay: state.appControls.showingOverlay,
  allowOverlayOnClick: state.appControls.allowOverlayOnClick,
  overlayZindex: state.appControls.overlayZindex,
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedOverlay);
